/** This composable is used to get the constants for the calculator. */
export const useCalculatorConsts = () => {
  return {
    FROM_PERIOD: 1 as const,
    MAX_SETTINGS_NAME_LENGTH: 40 as const,
    MAX_SAVED_SETTINGS_COUNT: 5 as const,
    EXPANDED_SECONDARY_ROW_MAX_HEIGHT: 76 as const,
    EXPANDED_PRIMARY_ROW_MAX_HEIGHT: 120 as const,
    EURIBOR_REFERENCE_RATE_PREFIX: 'EURIBOR' as const,
  };
};
